var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M11.6 11L21.876.723a.424.424 0 0 0-.6-.6L11 10.4.722.124a.424.424 0 0 0-.6.6L10.4 11 .124 21.278a.424.424 0 1 0 .6.6L11 11.6l10.278 10.276a.424.424 0 0 0 .6-.6z"}})}
var staticRenderFns = []

export { render, staticRenderFns }